module.exports = __webpack_public_path__ + "img/Event4.6d3c27e5.jpg";